/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VesselAdvancedVessel
 */
export interface VesselAdvancedVessel {
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    deadweightTonnage?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    grossTonnage?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    displacement?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    netTonnage?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    formerVesselName?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    buildPlace?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    buildYear?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    builder?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    engineType?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    enginePropulsionPowerKw?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    enginePropulsionType?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    enginePropulsionMethod?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    keelLaidDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    officialNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    engineMaker?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    engineYear?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedVessel
     */
    vesselMaterial?: any | null;
}

/**
 * Check if a given object implements the VesselAdvancedVessel interface.
 */
export function instanceOfVesselAdvancedVessel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VesselAdvancedVesselFromJSON(json: any): VesselAdvancedVessel {
    return VesselAdvancedVesselFromJSONTyped(json, false);
}

export function VesselAdvancedVesselFromJSONTyped(json: any, ignoreDiscriminator: boolean): VesselAdvancedVessel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deadweightTonnage': !exists(json, 'deadweight_tonnage') ? undefined : json['deadweight_tonnage'],
        'grossTonnage': !exists(json, 'gross_tonnage') ? undefined : json['gross_tonnage'],
        'displacement': !exists(json, 'displacement') ? undefined : json['displacement'],
        'netTonnage': !exists(json, 'net_tonnage') ? undefined : json['net_tonnage'],
        'formerVesselName': !exists(json, 'former_vessel_name') ? undefined : json['former_vessel_name'],
        'buildPlace': !exists(json, 'build_place') ? undefined : json['build_place'],
        'buildYear': !exists(json, 'build_year') ? undefined : json['build_year'],
        'builder': !exists(json, 'builder') ? undefined : json['builder'],
        'engineType': !exists(json, 'engine_type') ? undefined : json['engine_type'],
        'enginePropulsionPowerKw': !exists(json, 'engine_propulsion_power_kw') ? undefined : json['engine_propulsion_power_kw'],
        'enginePropulsionType': !exists(json, 'engine_propulsion_type') ? undefined : json['engine_propulsion_type'],
        'enginePropulsionMethod': !exists(json, 'engine_propulsion_method') ? undefined : json['engine_propulsion_method'],
        'keelLaidDate': !exists(json, 'keel_laid_date') ? undefined : json['keel_laid_date'],
        'officialNumber': !exists(json, 'official_number') ? undefined : json['official_number'],
        'engineMaker': !exists(json, 'engine_maker') ? undefined : json['engine_maker'],
        'engineYear': !exists(json, 'engine_year') ? undefined : json['engine_year'],
        'vesselMaterial': !exists(json, 'vessel_material') ? undefined : json['vessel_material'],
    };
}

export function VesselAdvancedVesselToJSON(value?: VesselAdvancedVessel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deadweight_tonnage': value.deadweightTonnage,
        'gross_tonnage': value.grossTonnage,
        'displacement': value.displacement,
        'net_tonnage': value.netTonnage,
        'former_vessel_name': value.formerVesselName,
        'build_place': value.buildPlace,
        'build_year': value.buildYear,
        'builder': value.builder,
        'engine_type': value.engineType,
        'engine_propulsion_power_kw': value.enginePropulsionPowerKw,
        'engine_propulsion_type': value.enginePropulsionType,
        'engine_propulsion_method': value.enginePropulsionMethod,
        'keel_laid_date': value.keelLaidDate,
        'official_number': value.officialNumber,
        'engine_maker': value.engineMaker,
        'engine_year': value.engineYear,
        'vessel_material': value.vesselMaterial,
    };
}

